import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import { normalizeTranslations } from '../../components/LocalizedContentTabs';
import { PetSkinFormFields, PET_SKIN_LANG_FIELDS } from './fields';

export const PetSkinEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'pet-skins' });
  const existing = queryResult?.data?.data as { translations?: any } | undefined;

  return (
    <Edit resource="pet-skins" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          // The slug is immutable server-side; sending it back would be ignored.
          const { slug: _slug, ...rest } = values;
          return formProps.onFinish?.({
            ...rest,
            translations: normalizeTranslations(
              values.translations,
              PET_SKIN_LANG_FIELDS,
              existing?.translations,
            ),
          });
        }}
      >
        <PetSkinFormFields slugEditable={false} />
      </Form>
    </Edit>
  );
};
